import { useEffect, useState } from "react";

// UI Toolkit components & utils
import {
  PanelWithDrawers,
  TopPanel,
  Drawer,
  DrawerContent,
} from "sj-ui-toolkit/src/atlas/components/PanelWithDrawers";
import { themeClasses as T, C } from "sj-ui-toolkit/src/atlas/utils/themeClasses";

// Context hooks
import { useAiHints } from "../contexts/SandboxHooks";
import { useLearnContext } from "../../../../context/LearnContext";

// Shared Lesson components
import LessonInfo from "../../LessonInfo";
import TournamentContentInfo from "../../../Tournament/Components/TournamentContentInfo";
import Notes from "../../Notes/Notes";
import ResourcesList from "../../Resources/ResourcesList";

// Sub-components
import SandboxText from "./SandboxText";
import HintsPanel from "./Aspen/HintsPanel";

// Styles
import S from "../../_Lesson.module.scss";

const LeftPanel = ({ lessonDetails }) => {
  const { aiHintsEnabled, hints, highlightedHint } = useAiHints();
  const { isTournament } = useLearnContext();

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [activeTabIndex, setActiveTabIndex] = useState(0); // 0: Notes, 1: Aspen

  const showAspenTab =
    aiHintsEnabled && lessonDetails.hasCodeTests && lessonDetails.type === "Break/Fix";

  // When the hints array changes length (or highlightedHint changes), open the drawer and switch to the Aspen tab
  useEffect(() => {
    if (highlightedHint) {
      setDrawerOpen(true);
      setActiveTabIndex(1); // Aspen tab
    }
  }, [hints.length, highlightedHint]);

  // When the drawer opens or closes, update drawerOpen state
  const handleOpenToggle = isOpen => {
    setDrawerOpen(isOpen);
  };

  return (
    <PanelWithDrawers className="h-full">
      <TopPanel id="lesson-left-panel-scroll" className={C("pr-3", S.leftPanelScroll, T.scrollbar)}>
        {!isTournament ? (
          <LessonInfo
            lessonType={lessonDetails.type}
            title={lessonDetails.title}
            description={lessonDetails.description}
            difficulty={lessonDetails.difficulty}
            duration={lessonDetails.duration}
          />
        ) : (
          <TournamentContentInfo
            lessonType={lessonDetails.type}
            title={lessonDetails.title}
            description={lessonDetails.description}
          />
        )}

        <div className="pt-3">
          <SandboxText />
        </div>
      </TopPanel>
      <Drawer
        startOpen={false}
        isOpen={drawerOpen}
        onOpenToggle={handleOpenToggle}
        activeTab={activeTabIndex}
        onTabChange={index => setActiveTabIndex(index)}
        initialHeight="50%"
        className={C(T.bgElevation1, "rounded-t-sm")}
        title="Notes"
      >
        <DrawerContent title="Notes" className="overflow-y-auto">
          <Notes lessonId={lessonDetails.id} />
        </DrawerContent>
        {showAspenTab && (
          <DrawerContent title="Aspen">
            <HintsPanel />
          </DrawerContent>
        )}
        {lessonDetails.resources && (
          <DrawerContent title="Resources">
            <ResourcesList resources={lessonDetails.resources} />
          </DrawerContent>
        )}
      </Drawer>
    </PanelWithDrawers>
  );
};

export default LeftPanel;
